import { Injectable } from '@angular/core';
import { IMultiselectOptions } from 'libraries/module/formbuilder/fields/multiselect/multiselect.model';
import { ILocale, LOCALE } from 'libraries/module/formbuilder/fields/date/config/locale';

@Injectable()
export class LocaleService {
    public locales: ILocale = LOCALE;

    public getMultiDaysOptions(language: string = 'fr'): IMultiselectOptions[] {
        return this.locales[language].dayNames.map((day: string, index: number) => {
            return {
                label: day,
                value: this.locales.en.dayNames[index],
            };
        });
    }
}